import { render, staticRenderFns } from "./CutoffReportPage.vue?vue&type=template&id=a8b361fa&scoped=true&"
import script from "./CutoffReportPage.vue?vue&type=script&lang=ts&"
export * from "./CutoffReportPage.vue?vue&type=script&lang=ts&"
import style0 from "./CutoffReportPage.vue?vue&type=style&index=0&id=a8b361fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b361fa",
  null
  
)

export default component.exports